import React from "react"
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import bannerImg from "../images/management/dataManagement/dataManagement.gif"
import mobbannerImg from "../images/management/dataManagement/mobDataManagement.gif"
import content1 from "../images/management/enterprise/ent-content.png"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import CustomProducts from "../components/cards/custom-products/index"
import NewProducts from "../components/cards/newproducts/index"
import product1 from "../images/management/dataManagement/1.png"
import product2 from "../images/management/dataManagement/2.png"
import product3 from "../images/management/dataManagement/3.png"
import product4 from "../images/management/dataManagement/4.png"
import product5 from "../images/management/dataManagement/5.png"
import product6 from "../images/management/dataManagement/6.png"
import product7 from "../images/management/dataManagement/7.png"
import icon1 from "../images/management/dataManagement/icon1.png"
import icon2 from "../images/management/dataManagement/icon2.png"
import icon3 from "../images/management/dataManagement/icon3.png"
import icon4 from "../images/management/dataManagement/icon4.png"
import icon5 from "../images/management/dataManagement/icon5.png"
import icon6 from "../images/management/dataManagement/icon6.png"
import icon7 from "../images/management/dataManagement/icon7.png"
import icon8 from "../images/management/dataManagement/icon8.png"
import icon9 from "../images/management/dataManagement/icon9.png"
import SubPageBanner from "../components/subpagebanner/SubPageBanner"
import { navigate } from "gatsby"

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem 6rem',
  },
  img: {
    height: '400px',
    width: '1200px',
  },
}))

const Management = ({ data, location: { pathname } }) => {

  const classes = useStyles()
  const theme = useTheme()

  const sectionData = {
    title: "Data Management",
    content: `Wersel Workdesk is a simple, efficient & user-friendly tool to\n manage data and data security. This platform allows the\n user and businesses to acquire & visualize data from\n various Data Hubs. Wersel also facilitates effective Data-\ndriven Management within the organization.`,
    buttonText: "Book Demo",
    buttonClick: () => navigate("/contact"),
    products: [
        {
            featureDescription:
              "Wersel Workdesk provides opportunities to showcase ",
            featureDescription2:
              "in a single location with high data security.",
            featureImage: product1,
            imagePosition: "right",
            list: [{icon: icon1, content: 'Sales data'}, {icon: icon2, content: 'Marketing data'} , {icon: icon3, content: 'Employee data'}, {icon: icon4, content: 'Social media data'}, 
            {icon: icon5, content: 'E-commerce data'} , {icon: icon6, content: 'Business data'}, {icon: icon7, content: 'FineTech data'}, {icon: icon8, content: 'Industrial data'}, {icon: icon9, content: 'Government data'}
            ],
            // url: "/products/discoverx/",
        },
        {
            featureDescription:
              "Wersel Workdesk is highly focused on Data Privacy of the data in the application by effective Identity Management, Data encryption, and Data access based on User and Organization.",
            featureDescription2:
              "It acts as an effective tool for the visualization of the data by using interactive dashboards which makes it easier to analyze, understand and work on enormous volumes of data.",
            featureImage: product2,
            imagePosition: "left",
            // url: "/products/discoverx/",
        },
        {
          featureTitle: "Management of Customer Data for Data Privacy",
          featureDescription:
            "Make data privacy a differentiator by handling client data with the sensitivity and care that your consumers expect from you. Access control and masking rules are used to protect client data with different blockchain-based encryption and tokenization approaches for maximum security.",
          featureImage: product3,
          imagePosition: "right",
          // url: "/products/discoverx/",
        },
        {
          featureTitle: "Detailed Data Residency",
          featureDescription:
            "Wersel Wordesk can host your regulated data in vaults located in the US, EU, India, or anywhere else in the world. Wersel Wordesk also satisfies additional GDPR and related legal requirements for data residence, such as data access control, auditing, and security. Privacy-focused data access control.",
          featureImage: product4,
          imagePosition: "left",
          hack: "hack-2500",
          // url: "/products/dashx/",
        },
        {
          featureTitle: "Paid in Compliance With PCI",
          featureDescription:
            'Utilize API interfaces with top payment processors to safely process credit card data, reducing your PCI compliance workload and enhancing security. Instead of being "locked-in" to a single payment processor, Wersel Workdesk allows you to route funds flexibly dependent on processor performance.',
          featureImage: product5,
          imagePosition: "right",
          // url: "/products/glassx/",
        },
        {
          featureTitle: "Access Control Focused on Privacy",
          featureDescription:
            "Limit the types of data that are accessible and their formats. Only provide your support team with the PII they require to assist your clients while maintaining data privacy. You can limit data access by IP address, only display last four digits of passport number & more. You can also provide access to only their designated customers during business hours. Always encrypted data analytics for data security and privacy.",
          featureImage: product6,
          imagePosition: "left",
          // url: "/products/discoverx/",
        },
        {
            featureTitle: "Analysis of Always-Encrypted Data",
            featureDescription:
              "PII's potential can be unlocked while client data privacy is maintained. You can query PII data without decrypting it and get the masked dataset you require, whether you're creating a machine learning model, studying overall customer behavior, or creating safe data triggers.",
            featureImage: product7,
            imagePosition: "right",
            // url: "/products/discoverx/",
          },
        // {
        //   featureTitle: "HR Software Analysis",
        //   featureDescription:
        //     "The HRs can make data-driven decisions using Wersel. The features such as AI-powered sentiment analysis, unified dashboards, and continuous analytics helps HR drive innovation and impact. The platform offers a connection between employee insights and decision-making.",
        //   featureImage: product5,
        //   imagePosition: "right",
        //   hack: "hack-2500",
        //   stylePadding: '10rem'
        //   // url: "/products/dashx/",
        // },
      ],
  }
   const { products, title, content, buttonClick, buttonText } = sectionData

  return (
    <Layout withBrand  slidePosition={0}>
      <SEO
        description="Deliver a phenomenal experience to your targeted shoppers and ensure that your brand maintains its credibility in the market with our brand analytics platform"
        keywords="brand analytics, brand analytics platform, brand analytics software, wersel, wersel brand analytics, wersel data hub"
        title="Wersel - AI Enabled People Analytics & Insights Software"
        url="www.wersel.io/"
      />
      <div style={{ paddingTop: '3px' }}>
        <SubPageBanner webbannerimg={bannerImg}  mobbannerimg={mobbannerImg} bannerHeading={title} bannerContent={content} buttonClick={buttonClick} buttonText={buttonText} />
      </div>
    {/* <Banner
        title={title}
        content={content}
        bannerImg={bannerImg}
        bannerBG={data?.bannerBG?.childImageSharp?.fluid?.src}
    /> */}
    <NewProducts features={products} homePage={true} type='management' />
    </Layout>
  )
}


export default Management
